import api from './api';

export const dashboardService = {
  getStats: async () => {
    const response = await api.get('/dashboard/stats');
    return response.data;
  },

  getSkillDistribution: async () => {
    const response = await api.get('/dashboard/top-skills?limit=10');
    return response.data;
  },

  getDepartmentBreakdown: async () => {
    const response = await api.get('/dashboard/department-distribution');
    return response.data;
  },

  getProficiencyDistribution: async () => {
    const response = await api.get('/dashboard/proficiency-distribution');
    return response.data;
  }
};
